(function () {
  var popupDelay = 14000;
  var popupText = 'UNLOCK 5% OFF';
  var blocked = new WeakSet();

  function isVisibleElement(element) {
    if (!(element instanceof HTMLElement)) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 220 && rect.height > 160;
  }

  function findPopupRoot(element) {
    var node = element;
    while (node && node !== document.body) {
      if (node instanceof HTMLElement && isVisibleElement(node)) {
        var style = window.getComputedStyle(node);
        if (style.position === 'fixed' || style.position === 'absolute') {
          return node;
        }
      }
      node = node.parentElement;
    }
    return null;
  }

  function delayPopup(root) {
    if (!root || blocked.has(root)) return;
    blocked.add(root);
    root.dataset.diggersDelayedPopup = 'true';
    root.style.setProperty('display', 'none', 'important');

    window.setTimeout(function () {
      if (!document.body.contains(root)) return;
      root.style.removeProperty('display');
    }, popupDelay);
  }

  function checkNode(node) {
    if (!(node instanceof HTMLElement)) return;
    if (!node.textContent || node.textContent.indexOf(popupText) === -1) return;

    var root = findPopupRoot(node);
    delayPopup(root);
  }

  function scan() {
    document.querySelectorAll('body *').forEach(checkNode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(checkNode);
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
